import type { OdinIconName } from '../../odin-icon/odin-icon.component';

export const isImageFile = (fileMimeType: string) => fileMimeType.includes('image');

export const isPdfFile = (fileMimeType: string) => fileMimeType === 'application/pdf';

export const getFileIcon = (fileMimeType: string) => {
  let icon: OdinIconName = 'File';
  if (fileMimeType.indexOf('image') > -1) {
    icon = 'Image';
  } else if (fileMimeType.indexOf('excel') > -1 || fileMimeType.indexOf('spreadsheet') > -1) {
    icon = 'FileSpreadsheet';
  } else if (fileMimeType.indexOf('wordprocessing') > -1 || fileMimeType.indexOf('msword') > -1) {
    icon = 'FileText';
  } else if (fileMimeType.indexOf('presentation') > -1) {
    icon = 'Presentation';
  }
  return icon;
};
